import React from 'react';
import './QualityCertificates.css';
/* DİL SİSTEMİ İMPORTU */
import { useLanguage } from '../../context/LanguageContext';

const QualityCertificates = () => {
  /* Dil fonksiyonlarını çekiyoruz kanka */
  const { t, lang } = useLanguage();

  const certificates = [
    {
      badge: "GMP+",
      title: "GMP+ Uyumlu Üretim", // Teknik isimler sabit kalabilir kanka
      desc: lang === 'TR' 
        ? "Hayvan yemi güvenliği ve üretim standardı." 
        : lang === 'AR' 
        ? "سلامة أعلاف الحيوانات ومعايير الإنتاج." 
        : "Animal feed safety and production standard."
    },
    {
      badge: "22000",
      title: "ISO 22000",
      desc: lang === 'TR' 
        ? "Gıda güvenliği yönetimi." 
        : lang === 'AR' 
        ? "إدارة سلامة الغذاء." 
        : "Food safety management."
    },
    {
      badge: "14001",
      title: "ISO 14001",
      desc: lang === 'TR' 
        ? "Çevre yönetimi ve sürdürülebilirlik." 
        : lang === 'AR' 
        ? "الإدارة البيئية والاستدامة." 
        : "Environmental management and sustainability."
    },
    {
      badge: "9001",
      title: "ISO 9001",
      desc: lang === 'TR' 
        ? "Kalite yönetim sistemi." 
        : lang === 'AR' 
        ? "نظام إدارة الجودة." 
        : "Quality management system."
    },
    {
      badge: "OHSAS",
      title: "OHSAS 18001",
      desc: lang === 'TR' 
        ? "İş sağlığı ve güvenliği." 
        : lang === 'AR' 
        ? "الصحة والسلامة المهنية." 
        : "Occupational health and safety."
    }
  ];

  return (
    <section className="quality-section">
      <div className="quality-container">
        <div className="quality-header">
          {/* t() fonksiyonu ile translations.js'den çekiyoruz kanka */}
          <span className="quality-badge-top">{t('quality.badge')}</span>
          <h2>{t('quality.title')}</h2>
          <p>{t('quality.desc')}</p>
        </div>

        <div className="quality-grid">
          {certificates.map((cert, index) => (
            <div key={index} className="quality-card">
              <div className="cert-badge-box">
                {cert.badge}
              </div>
              <h3>{cert.title}</h3>
              <p>{cert.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QualityCertificates;